/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs */

const en_admin_external_booking_edit_legacy_full_address_notice = /** @type {(inputs: Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separate address fields have not been filled in yet. We only have the full address:`)
};

const de_admin_external_booking_edit_legacy_full_address_notice = /** @type {(inputs: Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separate Adressfelder wurden noch nicht ausgefüllt. Wir haben nur die vollständige Adresse:`)
};

const es_admin_external_booking_edit_legacy_full_address_notice = /** @type {(inputs: Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no se han rellenado los campos de dirección por separado. Solo tenemos la dirección completa:`)
};

const fr_admin_external_booking_edit_legacy_full_address_notice = /** @type {(inputs: Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les champs d'adresse séparés n'ont pas encore été renseignés. Nous n'avons que l'adresse complète :`)
};

const nl_admin_external_booking_edit_legacy_full_address_notice = /** @type {(inputs: Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparte adresvelden zijn nog niet ingevuld. We hebben alleen het volledige adres:`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs) => LocalizedString} */
const it_admin_external_booking_edit_legacy_full_address_notice = en_admin_external_booking_edit_legacy_full_address_notice;

/** @type {(inputs: Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_legacy_full_address_notice = en_admin_external_booking_edit_legacy_full_address_notice;

/** @type {(inputs: Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs) => LocalizedString} */
const pl_admin_external_booking_edit_legacy_full_address_notice = en_admin_external_booking_edit_legacy_full_address_notice;

/** @type {(inputs: Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs) => LocalizedString} */
const hu_admin_external_booking_edit_legacy_full_address_notice = en_admin_external_booking_edit_legacy_full_address_notice;

/** @type {(inputs: Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs) => LocalizedString} */
const ro_admin_external_booking_edit_legacy_full_address_notice = en_admin_external_booking_edit_legacy_full_address_notice;

/**
* | output |
* | --- |
* | "Separate address fields have not been filled in yet. We only have the full address:" |
*
* @param {Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_legacy_full_address_notice = /** @type {((inputs?: Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Legacy_Full_Address_NoticeInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_legacy_full_address_notice(inputs)
	if (locale === "de") return de_admin_external_booking_edit_legacy_full_address_notice(inputs)
	if (locale === "es") return es_admin_external_booking_edit_legacy_full_address_notice(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_legacy_full_address_notice(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_legacy_full_address_notice(inputs)
	if (locale === "it") return it_admin_external_booking_edit_legacy_full_address_notice(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_legacy_full_address_notice(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_legacy_full_address_notice(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_legacy_full_address_notice(inputs)
	return ro_admin_external_booking_edit_legacy_full_address_notice(inputs)
});
export { admin_external_booking_edit_legacy_full_address_notice as "admin.external_booking_edit.legacy_full_address_notice" }